import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import { Container, Col, Row } from 'reactstrap';

import starsWhiteIcon from 'assets/images/stars-white.svg';

import GeneratorReview from './GeneratorReview';
import reviewsData from './data/reviews';

const GeneratorReviews = ({ reviews }) => (
  <div className="reviews" id="reviews">
    <img className="reviews__stars" src={starsWhiteIcon} alt="Review Stars" />
    <h2 className="reviews__heading">Our customers rate our generators 4.6 out of 5 stars.</h2>
    <Container>
      <Row>
        {
          reviews && reviews.map(review => (
            <Col style={{ display: 'flex' }} key={review.id} md={6} xs={12}>
              <GeneratorReview quote={review.quote} author={review.author} />
            </Col>
          ))
        }
      </Row>
    </Container>
  </div>
);

GeneratorReviews.propTypes = {
  reviews: PropTypes.array.isRequired,
};

const enhance = compose(
  withProps({
    reviews: reviewsData,
  }),
);

export default enhance(GeneratorReviews);



// WEBPACK FOOTER //
// ./src/views/Home/components/GeneratorReviews/index.js